import React from 'react';
import styles from './styles.module.scss';
import { useTranslation, Trans } from 'next-i18next';
import MarketingSection from 'src/components/MarketingSection';
import gridStyles from 'src/shared/theme/grid.module.scss';
import RoundedButton from 'src/shared/components/RoundedButton';
import useRouter from 'src/shared/hooks/useRouter';
import RoutePaths from 'src/config/RoutePaths';
import { fireGA } from 'src/utils/gaUtils';

const OfferingHeaderSection = () => {
    const { t } = useTranslation();
    const router = useRouter();

    const clickSignUp = () => {
        fireGA('marketingQ421', 'clickSignUp', 'Offerings');
        router.pushPath(RoutePaths.REGISTER);
    };

    return (
        <MarketingSection containerClassName={styles.offeringSection}>
            <div className={gridStyles.container}>
                <div className={gridStyles.lg12}>
                    <p className={styles.title}>{t('offerings_title')}</p>
                </div>
                <div className={gridStyles.lg7}>
                    <p className={styles.content}>
                        <Trans i18nKey="offerings_description" />
                    </p>
                </div>
                <div className={gridStyles.lg5}>
                    <div className={styles.buttonContainer}>
                        <RoundedButton className={styles.viewButton} type="white" onClick={clickSignUp}>
                            {t('sign_up_to_view_funds_button')}
                        </RoundedButton>
                    </div>
                </div>
            </div>
        </MarketingSection>
    );
};

export default OfferingHeaderSection;
